module.exports = __webpack_public_path__ + "static/media/membership-card-icon-active.e3f7a9ac.svg";